import React, { FC } from "react";
import { FormattedMessage } from "@I18n/Components/FormattedMessage/FormattedMessage";
import { PaymentMethodCard } from "../../../../Components/PaymentMethodCard/PaymentMethodCard";
import messages from "./messages";
import { IPaymentMethod } from "@modules/PaymentProcessing/services/paymentMethods";
import { PaymentMethodType } from "@modules/PaymentProcessing/types";

interface Props {
  onClick: (paymentMethod: IPaymentMethod) => void;
  disabled?: boolean;
}

export const BancontactPaymentCard: FC<Props> = ({ onClick, disabled }) => {
  return (
    <PaymentMethodCard
      title={<FormattedMessage {...messages.bancontact} />}
      onClick={onClick}
      cardNetworkIcons={["bancontact"]}
      value={PaymentMethodType.BANCONTACT}
      disabled={disabled}
      data-testid="bancontact-payment-link"
      disabledModalTitle={<FormattedMessage {...messages.noBancontact} />}
      disabledModalContent={
        <FormattedMessage
          {...messages.bancontactTransactionsAreNotSupportedForThisService}
        />
      }
    />
  );
};
